/**
 *
 * @module fairPlayCertificateStorage
 *
 */

import Services from './../services/entry';
import CertificateStorage from './certificateStorage';

const DrmType = Services.Media.DrmType;

/**
 *
 * @class FairPlayCertificateStorage
 * @extends {CertificateStorage}
 * @desc Provides a storage mechanism for storing a Fairplay Certificate.
 * @since 3.2.0
 *
 */
export default class FairPlayCertificateStorage extends CertificateStorage {

    /**
     *
     * @param {Sring} clientId
     * @param {String} environment
     * @param {SDK.Services.Storage} storage
     * @param {SDK.Logging.Logger} logger
     *
     */
    constructor(clientId, environment, storage, logger) {

        super(DrmType.FAIRPLAY, clientId, environment, storage, logger);

        this.logger.log(FairPlayCertificateStorage.name, 'Created.');

    }

}



// WEBPACK FOOTER //
// ./src/drm/fairPlayCertificateStorage.js